import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const GST_RATE = 18;

interface Props {
  basePrice: number | null;
  paymentUnit: string | null;
  quantity: number;
  discountPct: number;
  resourceLabel: string | null;
}

export function PricePreviewCard({ basePrice, paymentUnit, quantity, discountPct, resourceLabel }: Props) {
  if (basePrice == null || resourceLabel == null) {
    return (
      <Card>
        <CardHeader><CardTitle>Price Preview</CardTitle></CardHeader>
        <CardContent className="text-sm text-muted-foreground">Select a member and resource to see the price preview.</CardContent>
      </Card>
    );
  }
  const subtotal = basePrice * quantity;
  const discount = (subtotal * discountPct) / 100;
  const net = subtotal - discount;
  const gst = (net * GST_RATE) / 100;
  const total = net + gst;
  const unitLabel = paymentUnit === "Hour"
    ? `${quantity} hrs @ ₹${basePrice}/hr`
    : `1 ${paymentUnit?.toLowerCase()} @ ₹${basePrice}`;
  return (
    <Card>
      <CardHeader><CardTitle>Price Preview</CardTitle></CardHeader>
      <CardContent className="space-y-1 text-sm">
        <div>{resourceLabel} · {unitLabel}</div>
        <div className="flex justify-between">
          <span>Subtotal:</span>
          <span className="font-mono">₹{subtotal.toFixed(2)}</span>
        </div>
        {discountPct > 0 && (
          <div className="flex justify-between">
            <span>Discount ({discountPct}%):</span>
            <span className="font-mono">-₹{discount.toFixed(2)}</span>
          </div>
        )}
        <div className="flex justify-between">
          <span>Net amount:</span>
          <span className="font-mono">₹{net.toFixed(2)}</span>
        </div>
        <div className="flex justify-between">
          <span>GST ({GST_RATE}%):</span>
          <span className="font-mono">₹{gst.toFixed(2)}</span>
        </div>
        <div className="flex justify-between border-t pt-1 mt-1 text-xl font-semibold">
          <span>Total:</span>
          <span className="font-mono">₹{total.toFixed(2)}</span>
        </div>
      </CardContent>
    </Card>
  );
}
